import React, { Component } from 'react'
import Img from 'gatsby-image'
import Modal from '../components/Fleet/FleetModal'
import axios from 'axios'
import Helmet from 'react-helmet'
import { backendURL } from '../data/config.json'

import EmailOffers from '../components/EmailOffers'

class DealsEn extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.renderItems = this.renderItems.bind(this)
  }
  componentDidMount() {
    axios
      .get(`${backendURL}/api/deals`)
      .then(res => {
        const deals = res.data
        this.setState({ deals })
      })
  }
  renderItems() {
    return _.map(this.state.deals, (deal, i) => {
      const { code, image, title, description, published } = deal
       if (published) {
        return (
          <div key={i} className="item">

            <div className="image">
              <img
                src={`${backendURL}${image}`}
                alt={title}
              />
            </div>
            <div className="deal-content">
              <h2>{title.en}</h2>
              <div className="excerpt">{description.en}</div>
              <div className="reserve">
                <Modal btn="Reserve" couponCode={code} 
                lang={this.props.pathContext.langKey} />
              </div>
            </div>
          </div>
        )
      }else if(!published){
        return (
          <div>       
              <h1>"Coming soon"</h1>
          </div>
        )
      }
      return null
    })
  }
  render() {
    const { langKey: lang } = this.props.pathContext
    const { edges: items } = this.props.data.allEmailOffersJson
    return (
      <div className="page deals">
                  <Helmet
            title={`Best Car Rental Deals on Budget Nicaragua`}
            meta={[
              {
                name: 'description',
                content:
                  'Frequently Asked Questions about car rentals.',
              },
            ]}
            link={[
              {
                rel: 'alternate',
                hreflang: 'en',
                href:
                  './es/deals',
              },
            ]}
          />
        <div className="excerpt">
          <Img sizes={this.props.data.imageSharp.sizes} />
          <div className="content-wrapper">
            <h1>Budget Offers</h1>
            <div className="grid-wrapper">
            <div className="item">
                <EmailOffers
                  lang={lang}
                  items={items}
                  type="EmailOffers"
                  title="Email Offers"
                />
              </div>
            {this.renderItems()}</div>
          </div>
        </div>
      </div>
    )
  }
}

export const query = graphql`

query EmailOffersEn {
  imageSharp(id: { regex: "/deals-top-background/" }) {
    sizes(maxWidth: 1600) {
      ...GatsbyImageSharpSizes
    }
  }
  allEmailOffersJson {
    edges {
      node {
        title {
          en
          es
        }
        description {
          en
          es
        }
        button {
          en
          es
        }
        inputPlaceholder {
          en
          es
        }
        fieldname
      }
    }
  }
}
`
export default DealsEn



// WEBPACK FOOTER //
// ./src/pages/deals.en.js